import { AloMedia } from '@/models/alo/AloMedia';

export const getImageUrl = (image:AloMedia, w:number|null = null, h:number|null = null, mode:string|null = null, p:string|null = null) => 
{      
    const urlParams = new URLSearchParams();
    
    //si un parametre width est passée
    if (w != null) urlParams.append("w",w.toString())

    //si un parametre height est passée
    if (h != null) urlParams.append("h",h.toString())

    //si un parametre mode est passée et qu'il est valide
    if (mode != null && (mode == "max" || mode == "crop" || mode == "stretch" || mode == "carve"))
    {
      urlParams.append("mode",mode)
    }

    //si des parametres supplémentaires sont passés on les ajoute tel quels
    if (p != null)
    {
      const pParams = new URLSearchParams(p); 
      pParams.forEach((value,key)=> urlParams.append(key,value))
    }

    urlParams.append("format","webp")
    urlParams.append("webp.lossless","false")
    urlParams.append("webp.quality","80")
    
    const queryParam = urlParams.toString()

  if(image && image.slug) {
    const url = `/images/${(image.id%100).toString().padStart(2,'0')}/${image.slug}${image.mdaExt}`          
    return (queryParam && queryParam.length > 0) ? `${url}?${queryParam}`:url
  }  
  else return (queryParam && queryParam.length > 0) ? `/images/01/no-image.png?${queryParam}`:"/images/01/no-image.png"
}